import type { TFacet } from '@lucimark/shared/models/playlist'
import type { IAssetEntry, IAssetIndex, IQueueFrame } from '@/types'
import { facetAssetIndexKey } from '@lucimark/shared/helpers/facetAssetIndexKey'
import {
  SECTION_SUPPRESSION_ASSET_UNAVAILABLE,
  SECTION_SUPPRESSION_NO_ASSET,
  SECTION_SUPPRESSION_NOT_READY,
  SECTION_SUPPRESSION_UNSUPPORTED
} from '@/constants/sectionSuppressionMessages'

/**
 * Explains why a frame section hit the generic fallback (no widget slot, no native vnode).
 */
export function getSectionFallbackSuppressionReason(
  facet: TFacet,
  frame: IQueueFrame,
  assetIndex: IAssetIndex
): string {
  const f = facet as TFacet & { asset: string }
  if (!f.asset?.trim()) {
    return SECTION_SUPPRESSION_NO_ASSET
  }
  const key = facetAssetIndexKey(f)
  const entry = assetIndex[key] ?? assetIndex[f.asset]
  if (entry === undefined) {
    return SECTION_SUPPRESSION_ASSET_UNAVAILABLE
  }
  if (nativeEntryMissingRenderableVnode(entry)) {
    return SECTION_SUPPRESSION_NOT_READY
  }
  return SECTION_SUPPRESSION_UNSUPPORTED
}

/** True when entry exists but has no vnode for native (non-widget) rendering. */
export function nativeEntryMissingRenderableVnode(entry: IAssetEntry | undefined): boolean {
  if (!entry) {
    return false
  }
  if ('isWidget' in entry && entry.isWidget) {
    return false
  }
  return !('vnode' in entry && entry.vnode)
}
